<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="4" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/>
<path d="M10 9.5v5l4.5-2.5L10 9.5Z" fill="currentColor"/>
<path d="M7 21h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
</svg>
</template>
